module.exports = __webpack_public_path__ + "img/Doc02-20060194-002_1.fa33171b.jpg";